'use client';

import { useQuery } from '@tanstack/react-query';

import { UnauthQueryOptions } from '@/api';

import type { FilterOption } from '../../constants';
import { FilterCheckboxList } from '../FilterCheckboxList';
import { FilterChipGroup } from '../FilterChipGroup';
import { FilterDrawerShell } from '../FilterDrawerShell';
import { FilterSection } from '../FilterSection';
import { FilterSidebarShell } from '../FilterSidebarShell';

interface PolicyInfoFilterProps {
  isDrawerOpen: boolean;
  onCloseDrawer: () => void;
  onApplyDrawer: () => void;
  provisionCodes: string[];
  onToggleProvision: (code: string) => void;
  onReset: () => void;
}

export function PolicyInfoFilter({
  isDrawerOpen,
  onCloseDrawer,
  onApplyDrawer,
  provisionCodes,
  onToggleProvision,
  onReset,
}: PolicyInfoFilterProps) {
  const { data: provisionOptions = [], isLoading: isProvisionLoading } = useQuery({
    ...UnauthQueryOptions[
      'get:/wello/v2/allows/query/policies/codes/provision'
    ](),
    staleTime: Infinity,
    gcTime: Infinity,
    select: ({ context }): FilterOption<string>[] =>
      (context?.queryCodes ?? [])
        .filter((item): item is { code: string; value: string } =>
          Boolean(item.code && item.value),
        )
        .map((item) => ({ value: item.code, label: item.value })),
  });

  return (
    <>
      <FilterSidebarShell onReset={onReset}>
        <FilterSection title="지원형태">
          <FilterCheckboxList
            options={provisionOptions}
            selectedValues={provisionCodes}
            onToggle={onToggleProvision}
            isLoading={isProvisionLoading}
            skeletonCount={6}
          />
        </FilterSection>
      </FilterSidebarShell>

      <FilterDrawerShell
        isOpen={isDrawerOpen}
        onReset={onReset}
        onApply={onApplyDrawer}
        onClose={onCloseDrawer}
      >
        <div className="flex flex-col gap-12">
          <h3 className="font-700 text-Gray-900 typo-body4">지원형태</h3>
          <FilterChipGroup
            options={provisionOptions}
            selectedValues={provisionCodes}
            onToggle={onToggleProvision}
            isLoading={isProvisionLoading}
            skeletonCount={6}
          />
        </div>
      </FilterDrawerShell>
    </>
  );
}
